module.exports = __webpack_public_path__ + "img/CATEGORY ICON-08.97d95025.png";